import { useTranslation } from 'react-i18next';

import { useDevelopmentStatus } from '@/hooks';
import { Table } from '@tanstack/react-table';
import { OpportunityItemList } from '@/features/opportunities/types';
import { TableFilterDropdown } from './table-filter-dropdown';

export type DevelopmentStatusFilterProps = {
  readonly table: Table<OpportunityItemList>;
  readonly value?: string[];
  readonly onChange: (value: string[]) => void;
  readonly popoverFilter?: boolean;
};

export function DevelopmentStatusFilter({ table, value, onChange, popoverFilter }: DevelopmentStatusFilterProps) {
  const { t } = useTranslation(['home']);

  const { options: developmentStatus } = useDevelopmentStatus();

  return (
    <TableFilterDropdown
      column={table.getColumn('status')}
      title={t('Status')}
      options={developmentStatus}
      value={value}
      onChange={onChange}
      popoverFilter={popoverFilter}
    />
  );
}
